import { render } from "./LoginPhoneView.vue?vue&type=template&id=13988fa1&scoped=true"
import script from "./LoginPhoneView.vue?vue&type=script&lang=js"
export * from "./LoginPhoneView.vue?vue&type=script&lang=js"

import "./LoginPhoneView.vue?vue&type=style&index=0&id=13988fa1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13988fa1"]])

export default __exports__